module.exports = __webpack_public_path__ + "img/745.2182ec6b.png";